<template>
    <div>
        <div v-for="babyNum in range(response['BIRTH_NUMBER'])" :key="babyNum" class="mb-4">
            <div v-if="showBaby(babyNum, response)">
                <div v-if="response['BIRTH_NUMBER'] > 1" class="mb-2 fw-bold text-decoration-underline">
                    {{ props.question.header[participant.language] }}{{ babyNum }}
                </div>
                <div class="mb-2">{{ props.question.text[participant.language] }}</div>
                <div v-for="answer in props.question.answers" :key="answer.value" class="ms-4 mb-4 form-check">
                    <input 
                        class="form-check-input" 
                        type="radio" 
                        :name="props.question.variable + '_' + babyNum"
                        :id="props.question.variable + '_' + babyNum + '_' + answer.value"
                        :value="answer.value"
                        :checked="babyNumResponse(babyNum, response) == answer.value"
                        @click="event => updateResponseBabies(babyNum, response, event)"
                    >
                    <label 
                        class="form-check-label" 
                        :for="props.question.variable + '_' + babyNum + '_' + answer.value"
                    >
                        {{ answer.label[participant.language] }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'

    const { saveResponseBabies } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    function range(n) {
        return [...Array(n).keys()].map(x => x + 1);
    }

    function babyNumResponse(babyNum, response) {
        let jsonResponse

        if (response[props.question.variable] && typeof response[props.question.variable] === 'string') {
            try {
                jsonResponse = JSON.parse(response[props.question.variable])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response[props.question.variable] === 'object' && response[props.question.variable] !== null) {
            jsonResponse = response[props.question.variable]
        } else {
            return 0
        }

        return jsonResponse && jsonResponse['baby' + babyNum] ? jsonResponse['baby' + babyNum] : 0
    }


    function showBaby(babyNum, response) {
        let jsonResponse

        if (response['BABY_STATUS'] && typeof response['BABY_STATUS'] === 'string') {
            try {
                jsonResponse = JSON.parse(response['BABY_STATUS'])
            } catch (e) {
                console.dir(e)
                return 0
            }
        } else if (typeof response['BABY_STATUS'] === 'object' && response['BABY_STATUS'] !== null) {
            jsonResponse = response['BABY_STATUS']
        } else {
            return 0
        }

        return jsonResponse && jsonResponse['baby' + babyNum] == 2 ? false : true
    }


    function updateResponseBabies(babyNum, response, event) {
        let jsonResponse
        const responseVariable = response[props.question.variable]

        if (typeof responseVariable === 'string') {
            try {
                jsonResponse = JSON.parse(responseVariable)
            } catch (e) {
                console.dir(e);
                jsonResponse = {}
            }
        } else if (typeof responseVariable === 'object' && responseVariable !== null) {
            jsonResponse = responseVariable
        } else {
            jsonResponse = {}
        }

        const value = parseInt(event.target.value)
        jsonResponse['baby' + babyNum] = isNaN(value) ? event.target.value : value

        saveResponseBabies(props.question.variable, jsonResponse)
    }
</script>